import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Card, List, Tag } from 'antd'
import { getRequest, inventoryChangesUrl } from '../../config'
import FieldChanges from './FieldChanges'
import { actionColor, actionLabel, formatDateTime, viaLabel } from './utils'

// The last few bot changes to ONE car, on its page, so somebody looking at a car can see why it looks
// the way it does. Draws nothing when there are none: an empty card on every car that has never been
// near the bot would be noise on the page used most.
const RecentChangesCard = ({ carId }) => {
  const [rows, setRows] = useState([])

  useEffect(() => {
    if (!carId) return
    let alive = true
    getRequest(`${inventoryChangesUrl}?car=${encodeURIComponent(carId)}`, 'recent changes', () => {}).then(
      response => {
        if (alive && response.success) setRows((response.data.results || []).slice(0, 10))
      }
    )
    return () => {
      alive = false
    }
  }, [carId])

  if (rows.length === 0) return null

  return (
    <Card title="Recent bot changes" size="small" style={{ marginBottom: 16 }}>
      <List
        size="small"
        dataSource={rows}
        renderItem={row => (
          <List.Item>
            <div style={{ width: '100%' }}>
              <div>
                <Tag color={actionColor(row.action)}>{actionLabel(row.action)}</Tag>
                <span style={{ opacity: 0.65, fontSize: 12 }}>
                  {formatDateTime(row.createdAt)} · {row.actorName || viaLabel(row.via)}
                </span>
              </div>
              <FieldChanges changes={row.fieldsChanged} />
            </div>
          </List.Item>
        )}
      />
    </Card>
  )
}

RecentChangesCard.propTypes = { carId: PropTypes.string }

export default RecentChangesCard
